<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="5"
        class="pb-0"
      >
        <h2>
          <v-row dense>
            <v-col cols="12">
              <span style="display: inline-block;vertical-align: top;margin-right: 20px;">
                <v-icon class="mr-2">
                  mdi-truck-outline
                </v-icon>
                配車計画
              </span>
              <span style="display: inline-block;vertical-align: top;" class="text-h6 font-weight-regular">
                {{ targetDate | date_format('MM') }}/
              </span>
              <span class="text-h4 font-weight-light">
                {{ targetDate | date_format('DD') }}
              </span>
              <span class="text-h6 font-weight-regular" style="display: inline-block;width: 48px">
                {{ targetDate | date_format('ddd') }}
              </span>
              <div style="display: inline-block;">
                <div style="display: flex;">
                  <v-btn
                    icon
                    class="font-weight-bold"
                    @click="previousButtonClickEvent"
                  >
                    <v-icon large>
                      mdi-chevron-left
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="font-weight-bold"
                    @click="nextButtonClickEvent"
                  >
                    <v-icon large>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                  <cs-date-picker
                    :date.sync="targetDate"
                    @dateChangedCallback="targetDateChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-btn
                        v-model="targetDate"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        dark
                        elevation="0"
                        fab
                        small
                      >
                        <v-icon dark>
                          mdi-calendar-month-outline
                        </v-icon>
                      </v-btn>
                    </template>
                  </cs-date-picker>
                </div>
              </div>
            </v-col>
          </v-row>
        </h2>
      </v-col>
      <v-col cols="12" md="7" class="text-right">
        <allocation-switch-button
          :current-view="currentView"
          @switchView="switchView"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-card
                  v-for="driver in drivers"
                  :key="driver.id"
                  flat
                >
                  <v-card-text style="padding-top: 5px;padding-bottom: 5px;">
                    <v-row dense>
                      <v-col cols="12" md="2">
                        <v-btn
                          text
                          @click="showDriverAssignedDialogButtonClickEvent(driver)"
                        >
                          <v-avatar
                            color="primary"
                            size="30"
                          >
                            <v-img
                              v-if="driver.image_url"
                              :alt="`${driver.name} avatar`"
                              :src="driver.image_url | load_image_url"
                            />
                            <span v-else class="primary white--text" style="font-size: 80%;">
                              {{ driver.name.slice(0, 2) }}
                            </span>
                          </v-avatar>
                          &nbsp;<small style="text-decoration: underline">{{ driver.name }}</small>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="10">
                        <div
                          v-for="plan in driver.schedules"
                          :key="plan.id"
                          style="display: inline-block;width: 150px;vertical-align: middle;"
                          :class="plan.confirmed ? 'confirmed' : ''"
                        >
                          <template
                            v-if="plan.schedule_type === 'collection'"
                          >
                            <v-badge
                              v-if="plan.schedule_type === 'collection'"
                              :content="plan.schedule_type | task_type_label"
                              :title="plan.supplier_location_name"
                              color="info"
                              dark
                              inline
                              class="customBadge"
                            />
                            <span
                              v-if="plan.schedule_type === 'collection'"
                              class="location_name"
                              :title="plan.supplier_location_name"
                            >
                              {{ plan.supplier_location_name }}
                            </span>
                          </template>
                          <template v-else-if="plan.schedule_type === 'destination'">
                            <v-badge
                              v-if="plan.schedule_type === 'destination'"
                              inline
                              color="#555555"
                              :content="plan.schedule_type | task_type_label"
                              :value="plan.schedule_type | task_type_label"
                              :title="plan.trader_location_name"
                              class="customBadge"
                            >
                            </v-badge>
                            <span
                              v-if="plan.schedule_type === 'destination'"
                              class="location_name"
                              :title="plan.trader_location_name"
                            >
                              {{ plan.trader_location_name }}
                            </span>
                            <v-badge
                              v-if="plan.schedule_type === 'destination' && plan.schedules.length > 0"
                              inline
                              color="primary"
                              :content="plan.schedules.length + 1"
                              :value="plan.schedules.length + 1"
                              class="customBadge"
                            >
                            </v-badge>
                          </template>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <driver-schedule-dialog
      :enable-dialog="enableDriverScheduleDialog"
      :target-date="targetDate"
      :target-driver-id="targetDriverId"
      @closeEvent="closeDriverAssignedDialogCallback"
    />
  </div>
</template>

<script>
import AllocationSwitchButton from '../components/_SwitchButton'
import DriverScheduleDialog from '../dialogs/_DriverScheduleDialog'
import {mapActions} from "vuex";

export default {
  name: 'AllocationDailyView',
  components: {
    AllocationSwitchButton,
    DriverScheduleDialog,
  },
  mixins: [],
  props: {
    currentView: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      enableDriverScheduleDialog: false,
      menuButtonSelected: null,
      targetDate: null,
      targetDriverId: null,
      drivers: [],
      formattedDate: null,
    }
  },
  computed: {},
  watch: {
    menuButtonSelected (newVal) {
      this.$emit('switchView', newVal)
    },
    targetDate () {
      this.buildBodies()
    },

  },
  created() {
    this.targetDate = this.$dayjs().format("YYYY-MM-DD")
    this.buildBodies()
  },
  methods: {
    ...mapActions('DriverAllocationDriver', {
      fetchDrivers: 'index',
    }),
    showDriverAssignedDialogButtonClickEvent (user) {
      this.targetDriverId = user.id
      this.enableDriverScheduleDialog = true
    },
    switchView (viewType) {
      this.menuButtonSelected = viewType
    },
    buildBodies () {
      this.fetchDrivers({target_date: this.targetDate, without_instruction: true}).then((content) => {
        this.drivers = content.drivers
      })
    },
    closeDriverAssignedDialogCallback () {
      this.enableDriverScheduleDialog = false
    },
    previousButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(-1, 'days').format('YYYY-MM-DD')
    },
    nextButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(1, 'days').format('YYYY-MM-DD')
    },
    tomorrowButtonClickEvent () {
      // let tomorrow = moment().toDate()
      this.targetDate = this.$dayjs().add(1, 'days').format('YYYY-MM-DD')
    },
    /**
     * カレンダー日付変更　コールバック
     */
    targetDateChangedCallback (value) {
      this.targetDate = value;
    },
  }
}
</script>

<style scoped lang="scss">
.customBadge {
  display: inline-block;
  & .v-badge__badge {
    font-size: 10px;
  }
}

.confirmed {
  opacity: 0.4;
}
.space_in_bottom {
  margin-bottom: 10px;
}
.location_name {
  white-space:nowrap;
  width: 75%;
  overflow:hidden;
  text-overflow:ellipsis;
  display: inline-block;
  font-size: 12px;
  vertical-align: bottom;
}
</style>
